export default __webpack_public_path__ + "static/media/SCIENCE_EARTH_AND_SPACE.d417453b.svg";